import { h } from 'preact';

interface InquiryLoaderProps {
  message: string;
}

export function InquiryLoadingMessage(props: InquiryLoaderProps) {
  return (
    <div className="text-center my-2 hi-type-caption text-muted">
      <i className="fas fa-cog fa-spin" /> { props.message }
    </div>
  );
}

export function InquiryLoadFailureMessage(props: InquiryLoaderProps) {
  return (
    <div className="text-center my-2 text-danger hi-type-caption">
      <i className="fas fa-exclamation-triangle" /> { props.message }
    </div>
  );
}
